import {pingBackend} from "@services/helpers/sessionHandler";

// local state
const getDefaultState = () => {
  return {
    timer: null,
    registrationLink: '#',
    passwordLink: "#",
    myAccountLink: '#',
    user: {},
    showHelp: true,
    norms: []
  }
};

const getters = {};

const mutations = {
  updateShowHelp(state, showHelp) {
    state.showHelp = showHelp;
  },
  updateRegistrationLink(state, registrationLink) {
    state.registrationLink = registrationLink;
  },
  resetState(state) {
    //Object.assign(state, getDefaultState());
    // keep registrationLink: '#' and myAccountLink: '#',
    Object.assign(state, {timer: null, user: {}});
  },
  setTimer(state) {
    if (state.timer != null) {
      clearInterval(state.timer);
    }
    state.timer = setInterval(
      pingBackend,
      window.KEYCLOAK_REFRESH_MINUTES * 1000 * 60
    );
  },
  clearTimer(state) {
    clearInterval(state.timer);
  },
};

const state = getDefaultState();

const actions = {
  resetState({commit}) {
    commit("resetState");
  },
  setTimer({commit}) {
    commit("setTimer");
  },
  clearTimer({commit}) {
    commit("clearTimer");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
